// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__Tkvp7","footer":"ModalUpdate_footer__ETQy6"};